import { Route, withRouter, Switch } from "react-router-dom";
import SideNavigationBar from "components/SidebarNav/Sidebar";
import TopNavigationBar from "components/navbars/NavigationBar";
import Footer from "components/footer";
import { ProtectedRoute } from "components/ProtectedRoute";
// pages
// import HomePage from "App";
import React, { Suspense, lazy } from "react";
// import MainHomePage from "views/home/MainHomePage";
// import LoginPage from "views/login/LoginPage";
import UserPage from "views/users/UserPage";
//import MeterPage from "views/meter/MeterPage";
import RoutePage from "views/routes/RoutePage";
import SitesPage from "views/sites/SitesPage";
import CreateMeterPage from "views/meter/CreateMeterPage";
import CreateRoutePage from "views/routes/CreateRoutePage";
import CreateUserPage from "views/users/CreateUserPage";
import MeterReadingPage from "views/Readings/MeterReadingPage";
import CreateSitePage from "views/sites/CreateSitePage";
import RouteMeterMappingPage from "views/routes/RouteMeterMappingPage";
import RolesPage from "views/role/RolePage";
import CreateCustomerPage from "views/customer/CreateCustomerPage";
import CustomerPage from "views/customer/CustomerPage";
import RouteAssignementPage from "views/routes/RouteAssignementPage";
import ReportMasterPage from "views/report/ReportMasterPage";
import MasterRoutePage from "views/routes/Models/MasterRoutePage";
import RouteTransactionPage from "views/routes/Models/RouteTransactionPage";
import RouteHistory from "views/routes/Models/RouteHistory";
import ForgotPassword from "views/login/ForgotPassword";
import CustomerViewPage from "views/customer/CustomerViewPage";
import MeterViewPage from "views/meter/MeterViewPage";
import ReportTransactionPage from "views/report/ReportTransactionPage";
import BillingCyclePage from "views/billing/BillingCyclePage";
import BillingTransactionPage from "views/billing/BillingTransactionPage";
import SearchTransactionIdPage from "views/search/SearchTransactionIdPage";
import BillingInvoice from "views/billing/BillingInvoice";
import BillingSetupPage from "views/billing/BillingSetupPage";
import AMI_AMR_MeterReadingPage from "views/Readings/AMI_AMR_MeterReadingPage";
import MeterHistoryLog from "views/meter/MeterHistoryLog";
import ClearMeterHistory from "views/meter/ClearMeterHistory";
import MeterConfigurationPage from "views/meter/MeterConfigurationPage"
import NearByMeter from "views/meter/NearByMeter";
// import FlowMeterReadingPage from "views/Readings/FlowReadingPage"
// import PressureMeterReadingPage from "views/Readings/PressureReadingPage"
// import LevelMeterReadingPage from "views/Readings/LevelReadingPage"
import CreateSubzone from "views/zone/SubZonePage"
import CreateZoneAndSubZonePage from "views/zone/CreateZoneAndSubZonePage"
import ZoneAndSubZonePage from "views/zone/ZoneAndSubZonePage"
//import PressureMeterPage from "views/meter/pressureMeterPage"
//import flowMeterPage from "views/meter/flowMeterPage"
//import levelMeterPage from "views/meter/levelMeterPage"
//import ohtReadingsPage from "views/Readings/OhtReadingsPage"
//import ohtMeterPage from "views/meter/OhtMeterPage"
import RawMeterReadingPage from "views/Readings/AllRawReadingsPage";
// import FlowHistoryReadingsPage from "views/History_Readings/FlowHistoryReadingsPage";
// import PressureHistoryReadingsPage from "views/History_Readings/PressureHistoryReadings";
//import levelHistoryReadingsPage from "views/History_Readings/LevelHistoryReadingsPage";
import GraphLoader from "components/GraphLoader";


const LoginPage = lazy(() => import("views/login/LoginPage"));
const MainHomePage =  lazy(() => import("views/home/MainHomePage"));
const MeterPage =  lazy(() => import("views/meter/MeterPage"));
const flowMeterPage =  lazy(() => import("views/meter/flowMeterPage"));
const PressureMeterPage =  lazy(() => import("views/meter/pressureMeterPage"));
const levelMeterPage =  lazy(() => import("views/meter/levelMeterPage"));
const ohtMeterPage =  lazy(() => import("views/meter/OhtMeterPage"));
const FlowMeterReadingPage =  lazy(() => import("views/Readings/FlowReadingPage"));
const PressureMeterReadingPage =  lazy(() => import("views/Readings/PressureReadingPage"));
const LevelMeterReadingPage =  lazy(() => import("views/Readings/LevelReadingPage"));
const ohtReadingsPage = lazy(() => import("views/Readings/OhtReadingsPage"))
const FlowHistoryReadingsPage =  lazy(() => import("views/History_Readings/FlowHistoryReadingsPage"));
const PressureHistoryReadingsPage =  lazy(() => import("views/History_Readings/PressureHistoryReadings"));
const levelHistoryReadingsPage =  lazy(() => import("views/History_Readings/LevelHistoryReadingsPage"));
const  ohtHistoryReadingsPage  = lazy(() => import("views/History_Readings/OhtHistoryReadingsPage"));
export const RouterComponent = withRouter(({ location, history }) => {
    return (
        <div className="app-container">
            <div className="header-container top-navigation-bar-container">
                {
                    (location.pathname === "/login-page" || location.pathname.includes("/login/") || location.pathname === "/" || location.pathname === '/forget-password') ? "" : <TopNavigationBar history={history} />
                }
            </div>
            <div className="side-navigation-bar-container">
                {
                    (location.pathname === "/login-page" || location.pathname.includes("/login/") || location.pathname === "/" || location.pathname === '/forget-password') ? "" : <SideNavigationBar history={history} />
                }
            </div>
            <div className="main-container">
                <Switch>
                    <Suspense fallback={
                        <div className="graph-spinner-wrapper-home-page">
                            <GraphLoader />
                        </div>
                    }>
                        <Route exact path="/" render={(props) => <LoginPage {...props} />} />
                        <Route path="/login-page" render={(props) => <LoginPage {...props} />} />
                        <Route path="/login/user/:role" render={(props) => <LoginPage {...props} />} />
                        <Route path="/login/:clientID" render={(props) => <LoginPage {...props} />} />
                    <ProtectedRoute path="/route-page" component={RoutePage} />
                    {/* <ProtectedRoute path="/home-page" component={HomePage} /> */}
                    <ProtectedRoute path="/home-page" component={MainHomePage} />
                    <ProtectedRoute path="/user-page" component={UserPage} />
                    <ProtectedRoute path="/meter-page" component={MeterPage} />
                    <ProtectedRoute path="/sites-page" component={SitesPage} />
                    <ProtectedRoute path="/create-meter-page" component={CreateMeterPage} />
                    <ProtectedRoute path="/create-route-page" component={CreateRoutePage} />
                    <ProtectedRoute path="/create-user-page" component={CreateUserPage} />
                    <ProtectedRoute path="/meter-reading" component={MeterReadingPage} />
                    <ProtectedRoute path="/create-site-page" component={CreateSitePage} />
                    <ProtectedRoute path="/subzone-page" component={CreateSubzone} />
                    <ProtectedRoute path="/create-zone-subzone-page" component={CreateZoneAndSubZonePage} />
                    <ProtectedRoute path="/zone-subzone-page" component={ZoneAndSubZonePage} />
                    <ProtectedRoute path="/pressure-meter-page" component={PressureMeterPage} />
                    <ProtectedRoute path="/flow-meter-page" component={flowMeterPage} />
                    <ProtectedRoute path="/level-meter-page" component={levelMeterPage} />
                    <ProtectedRoute path="/oht-meter-page" component={ohtMeterPage} />
                    <ProtectedRoute path="/route-meter-mapping" component={RouteMeterMappingPage} />
                    <ProtectedRoute path="/roles-page" component={RolesPage} />
                    <ProtectedRoute path="/create-customer-page" component={CreateCustomerPage} />
                    <ProtectedRoute path="/customer-page" component={CustomerPage} />
                    <ProtectedRoute path="/route-assignement-page" component={RouteAssignementPage} />
                    <ProtectedRoute path="/report-master-page" component={ReportMasterPage} />
                    <ProtectedRoute path="/master-route-page" component={MasterRoutePage} />
                    <ProtectedRoute path="/route-transaction-page" component={RouteTransactionPage} />
                    <ProtectedRoute path="/route-history" component={RouteHistory} />
                    <Route path="/forget-password" render={(props) => <ForgotPassword {...props} />} />
                    <ProtectedRoute path="/customer-view-page" component={CustomerViewPage} />
                    <ProtectedRoute path="/meter-view-page" component={MeterViewPage} />
                    <ProtectedRoute path="/report-transaction-page" component={ReportTransactionPage} />
                    <ProtectedRoute path="/billing-cycle-page" component={BillingCyclePage} />
                    <ProtectedRoute path="/billing-transaction-page" component={BillingTransactionPage} />
                    <ProtectedRoute path="/search-transaction-id-page" component={SearchTransactionIdPage} />
                    <ProtectedRoute path="/billing-invoice" component={BillingInvoice} />
                    <ProtectedRoute path="/billing-setup-page" component={BillingSetupPage} />
                    <ProtectedRoute path="/ami-amr-meter-reading-page" component={AMI_AMR_MeterReadingPage} />
                    <ProtectedRoute path="/meter-history-log" component={MeterHistoryLog} />
                    <ProtectedRoute path="/clear-meter-history" component={ClearMeterHistory} />
                    <ProtectedRoute path="/meter-configuration-page" component={MeterConfigurationPage} />
                    <ProtectedRoute path="/map-view" component={NearByMeter} />
                    <ProtectedRoute path="/flow-readings-page" component={FlowMeterReadingPage} />
                    <ProtectedRoute path="/pressure-readings-page" component={PressureMeterReadingPage} />
                    <ProtectedRoute path="/level-readings-page" component={LevelMeterReadingPage} />
                    <ProtectedRoute path="/oht-readings-page" component={ohtReadingsPage} />
                    <ProtectedRoute path="/raw-readings-page" component={RawMeterReadingPage} />
                    <ProtectedRoute path="/flow-history-readings" component={FlowHistoryReadingsPage} />
                    <ProtectedRoute path="/pressure-history-readings" component={PressureHistoryReadingsPage} />
                    <ProtectedRoute path="/level-history-readings" component={levelHistoryReadingsPage} />
                    <ProtectedRoute path="/oht-history-readings" component={ohtHistoryReadingsPage} />
                    </Suspense>
                </Switch> 
            </div>
            <div className="footer-container">
                {
                    (location.pathname === "/login-page" || location.pathname.includes("/login/") || location.pathname === "/" || location.pathname === "/forget-password") ? "" : <Footer />
                }
            </div>
        </div>
    );
});
